import Store from './store';

const store = Store();

export const AppStore = store;